import { useEffect } from "react";

const SIZED_KEY = "maatra_pwa_window_sized";
const WINDOW_WIDTH = 500;
const WINDOW_HEIGHT = 900;

/**
 * Best-effort: resizes the installed app's window to phone-like dimensions
 * on its first standalone launch. Some browsers ignore resizeTo on windows
 * not opened via window.open(), in which case this silently no-ops — the
 * user can still resize the window once manually and the browser remembers
 * that size for future launches.
 */
export const useFitStandaloneWindow = (): void => {
  useEffect(() => {
    const isStandalone = window.matchMedia(
      "(display-mode: standalone)"
    ).matches;
    if (!isStandalone) return;
    if (localStorage.getItem(SIZED_KEY) === "true") return;

    window.resizeTo(WINDOW_WIDTH, WINDOW_HEIGHT);
    localStorage.setItem(SIZED_KEY, "true");
  }, []);
};
